import React, { useContext } from "react"
import { borderSubMain, clBasic, colores } from "./general"
import { AppContext } from "./index"

export default function ListaStories({ historias }) {
    let { firebase } = useContext(AppContext)
    let color = colores["prioridad"];

    function drag(e) {

    }

    return (
        <div style={SlistaHistoria}>
            {historias.map(h => {
                let s = firebase.historia(h)
                return (
                    < div style={Sstory} draggable="true" onDragStart={(e) => drag(e)} key={h}>
                        <div style={Slinea1}>
                            <div style={Snombre}>
                                {s.nombre}
                            </div>
                            <div style={{ ...Scirculo, background: color[s.prioridad] }}></div>
                        </div>

                        <div style={Slinea2}>
                            <div >
                                {`${s.puntos} puntos`}
                            </div>
                        </div>
                    </div >
                )
            }
            )}
        </div>
    )
}

const SlistaHistoria = {
    display: "grid",
    gridTemplateColumns: "14% 14% 14% 14% 14% 14% 14% ",
    minHeight: "4vh",
    marginBottom: "5px",
    color: clBasic
}

const Sstory = {
    width: "95%",
    background: "white",
    border: `2px outset ${borderSubMain}`,
    borderRadius: "0px 12px 0px  0px",
    color: clBasic,
    margin: "1px 1px 0px 1px "
}

const Slinea1 = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "2px 2px 0px 2px",
    fontSize: "1.1vh",
}

const Snombre = {
    width: "75%",
    whiteSpace: "nowrap",
    overflow: "hidden"
}

const Slinea2 = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "0px 2px 2px 2px",
    fontSize: "1.0vh"
}

const Scirculo = {
    height: "7px",
    width: "7px",
    padding: "5px",
    borderRadius: "50%",
}